import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSendOtp } from '../hooks/useQueries';
import './Login.css';

const Login = () => {
  const [email, setEmail]         = useState('');
  const [fieldError, setFieldError] = useState('');

  const navigate = useNavigate();
  const { mutateAsync: sendOtpFn, isPending } = useSendOtp();

  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());

  const handleNext = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setFieldError('Please enter your email address.');
      return;
    }
    if (!validateEmail(email)) {
      setFieldError('Please enter a valid email address.');
      return;
    }

    setFieldError('');

    try {
      await sendOtpFn(email.trim().toLowerCase());
      navigate('/verify-otp', { state: { email: email.trim().toLowerCase() } });
    } catch (err) {
      const apiMsg =
        err?.response?.data?.message ||
        'Something went wrong. Please try again.';
      setFieldError(apiMsg);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-bg__circle auth-bg__circle--1" />
        <div className="auth-bg__circle auth-bg__circle--2" />
        <div className="auth-bg__circle auth-bg__circle--3" />
      </div>

      <div className="auth-card-wrap">
        {/* ── Left panel — brand ── */}
        <div className="auth-brand">
          <Link to="/" className="auth-brand__logo">
            <img
              src="https://res.cloudinary.com/dfl6zlu16/image/upload/v1784294408/Untitled_design_cnrpon.png"
              alt="F Creation"
            />
          </Link>
          <h2 className="auth-brand__title">Gifts that speak<br />from the heart</h2>
          <p className="auth-brand__sub">
            Sign in to track orders, save your wishlist, and unlock personalised gifting.
          </p>
          <div className="auth-brand__features">
            {[
              { icon: '📦', text: 'Track all your orders in one place' },
              { icon: '♥',  text: 'Save favourites to your wishlist' },
              { icon: '🎀', text: 'Fast checkout with saved addresses' },
              { icon: '✨', text: 'Exclusive offers for members' },
            ].map((f, i) => (
              <div key={i} className="auth-feature">
                <span className="auth-feature__icon">{f.icon}</span>
                <span className="auth-feature__text">{f.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Right panel — form ── */}
        <div className="auth-form-panel">
          <div className="auth-form-inner">
            <div className="auth-form-header">
              <div className="auth-form-icon">👤</div>
              <h1 className="auth-form-title">Welcome back</h1>
              <p className="auth-form-sub">
                Enter your email to receive a one-time password.
                <p style={{color:'red'}}>Didn't receive your OTP? Please check your Spam folder.</p>
              </p>
            </div>

            <form onSubmit={handleNext} noValidate className="auth-form">
              <div className="auth-field">
                <label htmlFor="email" className="auth-label">Email Address</label>
                <div className="auth-input-wrap">
                  <span className="auth-input-icon">
                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <rect x="2" y="4" width="20" height="16" rx="2"/>
                      <path d="m2 7 10 7 10-7"/>
                    </svg>
                  </span>
                  <input
                    id="email"
                    type="email"
                    className={`auth-input ${fieldError ? 'auth-input--error' : ''}`}
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setFieldError(''); }}
                    autoFocus
                    autoComplete="email"
                    disabled={isPending}
                  />
                </div>
                {fieldError && <p className="auth-error">{fieldError}</p>}
              </div>

              <button
                type="submit"
                className={`auth-btn ${isPending ? 'auth-btn--loading' : ''}`}
                disabled={isPending}
              >
                {isPending ? (
                  <><span className="auth-spinner" /> Sending OTP…</>
                ) : (
                  <>Continue <span className="auth-btn-arrow">→</span></>
                )}
              </button>
            </form>

            <p className="auth-terms">
              By continuing, you agree to our{' '}
              <Link to="/policies">Terms of Service</Link> and{' '}
              <Link to="/policies">Privacy Policy</Link>.
            </p>

            <Link to="/" className="auth-back-link">
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
              </svg>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;